// extracted by mini-css-extract-plugin
module.exports = {"space":"DiskSpace-space-2ZmeJ TableRowCell-cell-2fbg4"};